var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClockAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 23",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 .07c-6.083 0-11 4.95-11 11a11 11 0 0 0 11 11c2.475 0 4.763-.836 6.6-2.2v-2.992c-1.617 1.826-3.971 2.992-6.6 2.992a8.8 8.8 0 1 1 0-17.6 8.78 8.78 0 0 1 8.151 5.5h2.343A10.97 10.97 0 0 0 11 .07m-1.1 5.5v6.6l5.775 3.465.825-1.353-4.95-2.937V5.57zm9.9 4.4v7.7H22v-7.7zm0 9.9v2.2H22v-2.2z"
})));
export default SvgClockAlert;